export default __webpack_public_path__ + "static/media/red.2736e480.png";